<template>
  <el-dialog
    :title="$t('affiliateRelationManage.addRelation')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="addAffiliateRelationInfo" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item :label="$t('affiliateRelationManage.relationLevel')" prop="name">
        <el-input
          v-model="addAffiliateRelationInfo.name"
          :placeholder="$t('affiliateRelationManage.relationLevelRequired')"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('affiliateRelationManage.expireTime')" prop="expireTime">
        <el-input
          v-model="addAffiliateRelationInfo.expireTime"
          :placeholder="$t('affiliateRelationManage.expireTimeRequired')"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAffiliateRelationInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAffiliateRelation } from '@/api/affiliate/affiliateRelationApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAffiliateRelation',
  data() {
    return {
      dialogVisible: false,
      addAffiliateRelationInfo: {
        name: '',
        expireTime: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('affiliateRelationManage.relationLevelRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('affiliateRelationManage.relationLevelMaxLength'), trigger: 'blur' }
        ],
        expireTime: [
          { required: true, message: this.$t('affiliateRelationManage.expireTimeRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('affiliateRelationManage.expireTimeMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addAffiliateRelationInfo = {
        name: '',
        expireTime: ''
      }
    },
    saveAffiliateRelationInfo() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        
        this.addAffiliateRelationInfo.shopId = getShopId()
        saveAffiliateRelation(this.addAffiliateRelationInfo)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('common.saveSuccess'))
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(error => {
            this.$message.error(this.$t('common.saveFailed'))
            console.error('请求失败处理:', error)
          })
      })
    }
  }
}
</script>